export const FIELD_TYPE_LABELS = {
  radio: "تک انتخابی تستی",
  checkboxes: "چند انتخابی",
  dropdown: "لیست کشویی",
  nps: "مقیاس عددی",
  text: "تشریحی کوتاه",
  paragraph: "تشریحی بلند",
  number: "عدد",
  date: "تاریخ",
  city: "شهر و استان",
  multitext: "چند متن",
  multidropdown: "چند لیست کشویی",
  break: "جدا کننده صفحه",
  html: "متن",
  voice: "صوت",
  image: "تصویر",
};

const NON_NUMBERED_TYPES = ["break", "html"];

const HTML_ENTITIES = {
  "&nbsp;": " ",
  "&amp;": "&",
  "&lt;": "<",
  "&gt;": ">",
  "&quot;": '"',
  "&#39;": "'",
};

const clean = (value) => {
  if (value == null) return "";
  return String(value)
    .replace(/<br\s*\/?>/gi, " ")
    .replace(/<\/(p|div|li|h[1-6])>/gi, " ")
    .replace(/<[^>]*>/g, "")
    .replace(/&nbsp;|&amp;|&lt;|&gt;|&quot;|&#39;/gi, (m) =>
      HTML_ENTITIES[m.toLowerCase()] ?? m
    )
    .replace(/\s+/g, " ")
    .trim();
};

const boolLabel = (value) => (value ? "بله" : "خیر");

const realOptions = (question) =>
  (question?.options ?? []).filter((option) => option?.label != null);

const buildRows = (question, number, parent) => {
  const base = {
    شماره: number,
    "شماره سوال": question.question_number ?? "",
    "سوال والد": parent ? clean(parent.label) : "",
    "نوع سوال": FIELD_TYPE_LABELS[question.field_type] ?? question.field_type ?? "",
    field_type: question.field_type ?? "",
    "عنوان سوال": clean(question.label),
    توضیحات: clean(question.description),
    اجباری: boolLabel(question.required),
    حداقل: question.min ?? "",
    حداکثر: question.max ?? "",
    "حداکثر انتخاب": question.selectLimit ?? "",
    "شناسه سوال": question.id ?? "",
  };

  const options = realOptions(question);

  if (!options.length) {
    return [
      {
        ...base,
        "ردیف گزینه": "",
        "عنوان گزینه": "",
        "شناسه گزینه": "",
        "قابل ویرایش": "",
      },
    ];
  }

  return options.map((option, optionIndex) => ({
    ...base,
    "ردیف گزینه": optionIndex + 1,
    "عنوان گزینه": clean(option.label),
    "شناسه گزینه": option.id ?? "",
    "قابل ویرایش": boolLabel(option.editable),
  }));
};

export const buildFormQuestionsRows = (questions) => {
  const rows = [];
  let number = 0;

  (questions ?? []).forEach((question) => {
    if (!NON_NUMBERED_TYPES.includes(question.field_type)) {
      number += 1;
    }
    const questionNumber = NON_NUMBERED_TYPES.includes(question.field_type)
      ? ""
      : String(number);

    if (question.field_type === "multidropdown" && question.questions?.length) {
      question.questions.forEach((child, childIndex) => {
        rows.push(
          ...buildRows(child, `${number}.${childIndex + 1}`, question)
        );
      });
      return;
    }

    rows.push(...buildRows(question, questionNumber));
  });

  return rows;
};

export default buildFormQuestionsRows;
